import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { ActivityNotificationService } from './activity-notification/activity-notification.service';
import { OeAppService } from './oe-app.service';
import { OneSignalService } from './one-signal.service';
import { AnalyticsOutcomeEvents } from './types/analytics-outcome.types';
import { CourseContentType } from './types/course-content-type';
import { ProgressResultDto } from './types/ProgressResultDto';
import { OeAppPersonService } from './oe-app-person.service';

@Injectable()
export class ImmersionCourseService {
  courseSaved = new EventEmitter<{ id: number; type: CourseContentType }>();

  constructor(
    private http: HttpClient,
    private activityNotificationService: ActivityNotificationService,
    private oneSignalService: OneSignalService,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  onCourseSaved(type?: CourseContentType) {
    return this.courseSaved.pipe(filter((data) => (!!type ? data.type === type : true)));
  }

  retrieveBookmark(courseId) {
    const url = `${this.oeAppService.courseServiceHost}/v1/courses/bookmarks?personId=${this.oeAppPersonService.id}&courseId=${courseId}`;
    return this.http.get<{ slide: number }>(url).pipe(
      map((bookmark) => (bookmark ? bookmark.slide : 0)),
      catchError(() => of(0))
    );
  }

  saveBookmark(courseId: number, slideIndex: number): Observable<any> {
    const url = `${this.oeAppService.courseServiceHost}/v1/courses/bookmark/${this.oeAppPersonService.id}/${courseId}/${slideIndex}`;
    // This should be a POST, there are legacy code in Lessons.js using a GET to save bookmark
    return this.http.get<any>(url);
  }

  savePersonCourse(
    timeOnTask: number,
    isComplete: boolean,
    courseId: number,
    courseType?: CourseContentType
  ): Observable<ProgressResultDto> {
    const payload = {
      timeOnTask,
      statusId: isComplete ? 2 : 1,
      course: { id: courseId },
    };
    if (isComplete) {
      this.oneSignalService.trackOutcome(this.getOutcomeType(courseType));
    }
    return this.http
      .put<ProgressResultDto>('/course/savepersoncourse', payload)
      .pipe(
        tap((data: ProgressResultDto) => {
          this.activityNotificationService.activityCompleted(
            {
              points: data.awardedPoints,
              badges: data.awardedBadges,
              overTheLimitActivity: data.overTheLimitActivity,
            },
            true,
            false
          );
          this.courseSaved.emit({ id: courseId, type: courseType });
        })
      );
  }

  calculateTimeOnTask(startTime: number) {
    return Math.floor(Date.now() / 1000 - startTime);
  }

  private getOutcomeType(courseType: CourseContentType): AnalyticsOutcomeEvents {
    switch (courseType) {
      case CourseContentType.VIDEOS:
        return AnalyticsOutcomeEvents.ENGLISH_CENTRAL_PRACTICE_COMPLETED;
      case CourseContentType.DAILY_NEWS:
        return AnalyticsOutcomeEvents.NEWS_PRACTICE_COMPLETED;
      case CourseContentType.IDIOMS:
        return AnalyticsOutcomeEvents.COMMON_EXPRESSIONS_PRACTICE_COMPLETED;
      case CourseContentType.PRONUNCIATIONS:
        return AnalyticsOutcomeEvents.PRONUNCIATION_PRACTICE_COMPLETED;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/immersion-course.service.ts